import React from 'react';

const CancellationAndRefund = () => {
  return (
    <div className="page">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img 
            src={`${process.env.PUBLIC_URL}/icon.png`}
            alt="HeyGerman Logo" 
            style={{ 
              width: '60px', 
              height: '60px', 
              borderRadius: '50%',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
              marginBottom: '20px'
            }} 
          />
        </div>
        <h1 style={{ textAlign: 'center', marginBottom: '40px', color: '#333' }}>
          Cancellation and Refund Policy
        </h1>
        
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Digital Service Policy</h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.7', color: '#555', marginBottom: '20px' }}>
              HeyGerman provides digital educational services including online German language courses, 
              consultation sessions, and educational materials. Please read our cancellation and refund 
              policy carefully before making any purchase.
            </p>
            <div style={{ padding: '20px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffeaa7' }}>
              <p style={{ color: '#856404', margin: 0, fontWeight: '500' }}>
                <strong>Important Notice:</strong> All sales of digital services are final. We do not provide 
                refunds or cancellations once the service has been purchased and delivered.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>No Refund Policy</h2>
            <div style={{ display: 'grid', gap: '20px' }}>
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>🚫 Digital Services</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  All digital services including online courses, consultation sessions, downloadable materials, 
                  and educational content are non-refundable once purchased and accessed.
                </p>
              </div>
              
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>📚 Course Materials</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  Digital course materials, PDFs, videos, audio files, and other educational resources 
                  cannot be returned or refunded after purchase and download.
                </p>
              </div>
              
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>💬 Consultation Services</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  One-to-one consultation sessions, group sessions, and advisory services are 
                  non-refundable once scheduled and conducted.
                </p>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Cancellation Policy</h2>
            <div style={{ padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
              <h3 style={{ color: '#333', marginBottom: '15px' }}>Service Cancellation</h3>
              <ul style={{ color: '#666', lineHeight: '1.6', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Digital Products:</strong> Cannot be cancelled once purchased and delivered to your account.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Live Sessions:</strong> Must be cancelled at least 24 hours before the scheduled time. 
                  No refund will be provided for late cancellations.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Subscription Services:</strong> Can be cancelled before the next billing cycle. 
                  No partial refunds for current billing period.
                </li>
              </ul>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Terms and Conditions</h2>
            <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <h3 style={{ color: '#333', marginBottom: '15px' }}>Before Purchase</h3>
              <p style={{ color: '#666', lineHeight: '1.6', marginBottom: '15px' }}>
                By purchasing any service from HeyGerman, you acknowledge and agree to the following:
              </p>
              <ul style={{ color: '#666', lineHeight: '1.6', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>
                  You have read and understood our complete terms and conditions
                </li>
                <li style={{ marginBottom: '8px' }}>
                  You agree to our no-refund policy for digital services
                </li>
                <li style={{ marginBottom: '8px' }}>
                  You understand that digital products cannot be returned
                </li>
                <li style={{ marginBottom: '8px' }}>
                  You are responsible for ensuring service compatibility with your requirements
                </li>
                <li style={{ marginBottom: '8px' }}>
                  All purchases are final and binding
                </li>
              </ul>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Exceptional Circumstances</h2>
            <div style={{ padding: '20px', backgroundColor: '#e8f4fd', borderRadius: '8px', border: '1px solid #bee5eb' }}>
              <p style={{ color: '#0c5460', margin: 0, lineHeight: '1.6' }}>
                <strong>Technical Issues:</strong> If you experience technical problems that prevent you from 
                accessing purchased digital services due to issues on our end, please contact our support team 
                within 48 hours of purchase. We will work to resolve technical issues but cannot guarantee refunds.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Contact Information</h2>
            <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <p style={{ color: '#666', marginBottom: '15px', lineHeight: '1.6' }}>
                If you have any questions about this Cancellation and Refund Policy, please contact us:
              </p>
              <div style={{ display: 'grid', gap: '10px' }}>
                <p style={{ color: '#666', margin: 0 }}>
                  <strong>Email:</strong> pawankumar@babycode.org
                </p>
                <p style={{ color: '#666', margin: 0 }}>
                  <strong>Phone:</strong> +919030870876
                </p>
                <p style={{ color: '#666', margin: 0 }}>
                  <strong>Address:</strong> 91springboard, F948+W7, Kondapur, Laxmi Cyber City, 
                  Whitefields, HITEC City, Hyderabad, Telangana 500084
                </p>
              </div>
            </div>
          </div>

          <div style={{ padding: '20px', backgroundColor: '#dc3545', borderRadius: '8px', textAlign: 'center' }}>
            <p style={{ color: 'white', margin: 0, fontSize: '1.1rem', fontWeight: '500' }}>
              ⚠️ Please ensure you understand and agree to these terms before making any purchase. 
              All sales are final for digital services.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancellationAndRefund;
